export const FIXED_ALLOC_EMPTY_ARRAY = Object.freeze([]);
